<template>
  <div id="TrustSection" >
    <b-container>
        <b-row>
            <b-col>
                <h3 class="title" v-html="acf.acf.titleTrusted"></h3>
                <p class="description" v-html="acf.acf.descriptionTrusted"></p>
            </b-col>
            <!-- <b-col>
                <img src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/Trusted_Logos.png" class="imageTrusted">
            </b-col> -->
        </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Trusted Section',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    // isMobile() {
    //     if( screen.width <= 768 ) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    // },
  },
  mounted() {
    axios //add API Call
        .get(
           process.env.VUE_APP_API_URL + 'pinpos' + "/wp-json/wp/v2/pages/13" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>
<style scoped>
img.imageTrusted {
    width: 100%;
}
#TrustSection {
    padding-top: 100px;
    padding-bottom: 30px;
}
.images {
    width: 100%;
}
.title {
    font-size: 50px;
    font-family: DIN Condensed, Bold;
    color: #0054E8;
    text-align: left;
    padding-bottom: 50px;
}
p {
    text-align: left;
    font-size: 24px;
    color: #000000;
    padding-bottom: 50px;
}
button.getintouch {
    padding: 14px 14px 14px 14px;
    background-color: #2CD55B;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #2CD55B;
    font-size: 24px;
    font-weight: bold;
    float: left;
}
button.getintouch:hover {
    padding: 14px 14px 14px 14px;
    background-color: #0054E8;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #0054E8;
    font-size: 24px;
    font-weight: bold;
    float: left;
}

/* Css for mobile */
@media only screen and (max-width: 1280px) {
    #TrustSection {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .title {
        padding-bottom: 20px;
    }
    p {
        text-align: left;
        font-size: 18px;
        color: #000000;
        padding-bottom: 0px;
    }
}
</style>
